import {
    Component,
    OnInit,
    OnDestroy,
    AfterViewInit,
    ViewChild,
    ElementRef
} from "@angular/core";
import { ActivatedRoute, Router, RoutesRecognized } from "@angular/router";
import { Location } from "@angular/common";
import { Store } from "@ngrx/store";
import { AppState } from "../../../../app.reducer";
import {
    GetMyFilesAndFolders,
    GetAllDocuments,
    GetAllCmpDocuments,
    GetSharedDocuments,
    GetFilesInMyFolder,
    GetCitisFolders
} from "../_store/resources.actions";

import { NgxPermissionsService } from "ngx-permissions";
import { GetUserCapabilites, ClearAction, ErrorAction } from "src/app/login/store/auth.actions";
import { ViewListService } from '../../../../services/list-grid-view.service'



@Component({
    selector: "docs-sort-selector",
    templateUrl: "./docs-sort-selector.component.html",
    styleUrls: ["./docs-sort-selector.component.scss"]
})

export class DocSortSelectorComponent
    implements OnInit {

    sortBy: string = 'date'
    sortOrder: string = 'desc'
    pageLimit: number = 0


    constructor(
        private route: ActivatedRoute,
        public location: Location,
        private store: Store<AppState>,
        private router: Router,
        private ngxPermissionService: NgxPermissionsService,
        public activateRoute: ActivatedRoute,
        private viewData: ViewListService
    ) { }

    ngOnInit() {
        this.viewData.CurrentLimit.subscribe(res => {
            this.pageLimit = res
        })
    }

    sortDoc(sortBy, sortOrder) {
        if (this.route.snapshot.url[0].path) {
            const payload = { 'page': 1, 'limit': this.pageLimit, 'sortOrder': sortOrder, 'sortBy': sortBy }

            this.viewData.changeSortOptions(sortBy, sortOrder, this.pageLimit)

            switch (this.route.snapshot.url[0].path) {
                case 'me':
                    if (this.route.snapshot.url[1].path != '') {
                        if (this.route.snapshot.url[1].path == 'citis'){
                            this.store.dispatch(new GetFilesInMyFolder(this.route.snapshot.url[2].path, payload));
                        }else{
                            this.store.dispatch(new GetFilesInMyFolder(this.route.snapshot.url[1].path, payload));
                        }
                    }
                    else{
                        this.store.dispatch(new GetMyFilesAndFolders(payload));
                    this.store.dispatch(new GetCitisFolders(payload));
                    }
                    break
                case 'shared-with-me':
                    this.store.dispatch(new GetSharedDocuments(payload));
                    break
                case 'list':
                    this.store.dispatch(new GetAllDocuments(payload));
                    break
                case 'all':
                    this.store.dispatch(new GetAllCmpDocuments(payload));
                    break
            }
        }
    }

    sortByChange(param) {
        this.sortBy = param
        this.sortDoc(this.sortBy, this.sortOrder)
    }

    changeSortOrder(sortOrder) {
        this.sortOrder = sortOrder
        this.sortDoc(this.sortBy, this.sortOrder)
    }
}